export default __webpack_public_path__ + "cache-volatile-tile-fetching-scheme-960-8e63c84807c181b6588422c922fb5c78.png";